import { selectPlaceTemplatesData } from 'containers/MapDetails/placeSlice'
import { useReduxSelector } from 'store'
import Icon from 'components/Icon'
import React from 'react'

interface WarehouseNotesProps extends playground.Warehouse { }

const WarehouseNotes: React.FC<WarehouseNotesProps> = ({ style, warehouseData, note, displayable }) => {
  const options = useReduxSelector(selectPlaceTemplatesData)

  return (
    <div
      className='object__note'
      style={style}>
      {warehouseData?.client && <div className='object__note__group'>
        <Icon
          bgColor='#7c7c7c'
          icon={warehouseData.client.icon}
        />
        <span>{warehouseData.client.text}</span>
      </div>}
      {displayable && areThereOptions(options) ? Object.entries(options).map(([key, isVisible]) => {
        const value = displayable[key]
        if (isVisible && value) {
          if (Array.isArray(value)) {
            return (value as string[]).map((icon, idx) => <Icon
              key={idx}
              icon={icon}
              bgColor='#7c7c7c'
            />)
          }

          if (typeof value === 'object' && 'icon' in value && 'text' in value) {
            return <div
              key={key}
              className='object__note__group'>
              <Icon
                bgColor='#7c7c7c'
                icon={value.icon}
              />
              <span>{value.text}</span>
            </div>
          }

          return <div key={key}>
            {value}{key === 'area' ? <> m<sup>2</sup></> : ''}
          </div>
        } return false
      }) : null}
    </div>
  )
}

const areThereOptions = (options: Record<string, boolean>): boolean => {
  for (const key in options) {
    if (options[key]) return true
  }
  return false
}

export default WarehouseNotes